import { AnimatePresence, motion } from 'framer-motion';
import { Paperclip } from 'lucide-react';

import { useDragHandlersRef } from './chat-input-context';

interface DragOverlayProps {
  className?: string;
}

/**
 * Drag overlay component that shows when files are being dragged over the input.
 * Reads drag state from drag handlers ref (populated by ChatAttachments if rendered).
 */
export function DragOverlay({ className }: DragOverlayProps) {
  const handlersRef = useDragHandlersRef();
  const isDragging = handlersRef.current.isDragging ?? false;

  return (
    <AnimatePresence>
      {isDragging && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={`border-rebrand-400 bg-background/70 absolute inset-0 z-50 flex items-center justify-center gap-3 rounded-lg border border-dashed p-4 ${className || ''}`}
        >
          <Paperclip size={24} />
          <div className="flex flex-col gap-1">
            <p className="text-base font-medium">Drop files here to attach</p>
            <p className="text-muted-foreground text-sm">Supports PDF, Office, email, ZIP, and image files</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
